import React from "react";
import { useParams } from "react-router-dom";

const ServiceOutcome = () => {
  const { slug } = useParams();


  const renderContent = () => {
    switch (slug) {
      case "web-development-services":
        return (
          <div>
            <h3 className="details_item_info_title">
              Web Development Services Outcome
            </h3>
            <p>
              At RashTech Info, our web development services are focused on
              creating websites that deliver real business results. As the Best
              Web Development Company in Alwar, we build responsive, fast, and
              SEO-friendly websites that not only look professional but also
              drive traffic and conversions. Whether it’s a business website,
              e-commerce platform, or custom web application, our Web
              Development Services in Alwar and across India are designed to
              give your brand a strong digital identity.
            </p>
            <ul
              className="grid grid-cols-2 gap-x-8 gap-y-3 list-disc list-inside marker:text-blue-600 marker:text-2xl"
              style={{ listStyleType: "square", fontSize: "18px" }}
            >
              <li>Professionally designed, mobile-friendly websites</li>
              <li>Faster loading speed and improved user experience</li>
              <li>SEO-friendly structure for better Google rankings</li>
              <li>Secure and scalable websites to support business growth</li>
              <li>Customized designs aligned with your brand identity</li>
              <li>Increased inquiries, sales, and customer engagement</li>
            </ul>
          </div>
        );
      case "seo-services":
        return (
          <div>
            <h3 className="details_item_info_title">SEO Services Outcome</h3>
            <p>
              At RashTech Info, our SEO Services are designed to deliver
              measurable growth, not just rankings. As the Best SEO Company in
              Alwar, we focus on results that directly benefit your business.
              From improving visibility on Google to driving organic traffic,
              our SEO strategies ensure that your brand stays ahead of
              competitors both locally and globally. With our expertise in SEO
              Services in Alwar and across India, we help businesses build a
              strong digital presence, generate qualified leads, and boost
              sales.
            </p>
            <ul
              className="grid grid-cols-2 gap-x-8 gap-y-3 list-disc list-inside marker:text-blue-600 marker:text-2xl"
              style={{ listStyleType: "square", fontSize: "18px" }}
            >
              <li>Higher Google rankings for targeted keywords</li>
              <li>Increased organic traffic and better audience reach</li>
              <li>Improved local SEO visibility in Alwar and nearby regions</li>
              <li>More qualified leads, inquiries, and conversions</li>
              <li>Enhanced brand authority and online credibility</li>
              <li>
                Long-term, sustainable SEO growth backed by proven strategies
              </li>
            </ul>
          </div>
        );
      case "app-development-services":
        return (
          <div>
            <h3 className="details_item_info_title">
              App Development Services Outcome
            </h3>
            <p>
              We don't merely create apps at RashTech Info — we design solutions
              that produce measurable results. Being the Best App Development
              Company in Alwar, our emphasis is to create applications that are
              innovative, secure, and in line with your business objectives.
              Each application we build is developed to offer seamless
              performance, intuitive user experience, and the capability to grow
              exponentially in the future. Our development process makes sure
              your app increases your brand visibility, enhances customer
              interaction, and brings more conversions. Through constant
              maintenance and upgradation, we ensure your application stays
              secure, speedy, and up-to-date in a competitive marketplace.
            </p>
            <ul
              className="grid grid-cols-2 gap-x-8 gap-y-3 list-disc list-inside marker:text-blue-600 marker:text-2xl"
              style={{ listStyleType: "square", fontSize: "18px" }}
            >
              <li>Custom-Built Mobile Apps for Unique Business Needs</li>
              <li>Scalable and Future-Ready Applications for Growth</li>
              <li>High-Performance Solutions with Reliable Functionality</li>
              <li>Cross-Platform Expertise for iOS and Android Apps</li>
              <li>User-Friendly UI/UX Designs for Better Engagement</li>
              <li>Secure and Reliable Systems for Data Protection</li>
            </ul>
          </div>
        );
      case "smo-services":
        return (
          <div>
            <h3 className="details_item_info_title">SMO Services Outcome</h3>
            <p>
              At RashTech Info, our SMO Services Alwar are crafted to establish
              strong social presence for businesses. With compelling content,
              specific campaigns, and ongoing optimization, we make your brand
              prominent locally, nationwide across India, and worldwide.
            </p>
            <ul
              className="grid grid-cols-2 gap-x-8 gap-y-3 list-disc list-inside marker:text-blue-600 marker:text-2xl"
              style={{ listStyleType: "square", fontSize: "18px" }}
            >
              <li>Enhanced brand visibility and awareness</li>
              <li>Increased target audience engagement</li>
              <li>Following, lead, and conversion growth</li>
              <li>Increased Traffic from Social Media</li>
              <li>Regular brand appearance across platforms</li>
              <li>Enhanced trust and better customer connections</li>
            </ul>
          </div>
        );
      case "graphic-design-services":
        return (
          <div>
            <h3 className="details_item_info_title">
              Graphic Design Services Outcome
            </h3>
            <p>
              Through RashTech Info, our Graphic Design Solutions in Alwar have
              the ability to make long-lasting impressions. We help businesses
              to communicate, engage customers, and make their brand known. Our
              innovative designs echo your brand identity everywhere and are
              customized to local as well as international audiences.
            </p>
            <ul
              className="grid grid-cols-2 gap-x-8 gap-y-3 list-disc list-inside marker:text-blue-600 marker:text-2xl"
              style={{ listStyleType: "square", fontSize: "18px" }}
            >
              <li>Increased brand identity and awareness</li>
              <li>Fascinating designs that draw attention</li>
              <li>Higher engagement on online platforms</li>
              <li>Consistent visual language across channels</li>
              <li>Stronger Customer Connection & Retention</li>
              <li>
                Professional-looking designs that build trust and confidence
              </li>
            </ul>
          </div>
        );
      case "video-editing-services":
        return (
          <div>
            <h3 className="details_item_info_title">
              Video Editing Services Outcome
            </h3>
            <p>
              Here at RashTech Info, our Alwar Video Editing Services aim to
              leave a lasting impact with our videos. We do not simply trim and
              cut frames; we create professional videos that build your brand,
              narrate your story, and grab attention. Our solutions create
              awareness, consolidate brand identity, and foster audience
              interest in India and internationally.
            </p>
            <ul
              className="grid grid-cols-2 gap-x-8 gap-y-3 list-disc list-inside marker:text-blue-600 marker:text-2xl"
              style={{ listStyleType: "square", fontSize: "18px" }}
            >
              <li>
                Professional-standard videos with frictionless transitions
              </li>
              <li>Content that resonates and keeps the viewer engaged</li>
              <li>Increased exposure on social and digital media</li>
              <li>Brand name and consumer trust drive</li>
              <li>Customized videos that serve your business requirements</li>
              <li>Higher Audience Retention & Watch Time</li>
            </ul>
          </div>
        );
      case "ui-ux-development-services":
        return (
          <div>
            <h3 className="details_item_info_title">
              UI/UX Development Services Outcome
            </h3>
            <p>
              At RashTech Info, our Alwar UI/UX Development Services are aimed
              at creating experiences that count. We don't merely create
              gorgeous layouts — we create digital experiences that resonate
              with users. Our products optimise business conversions, improve
              customer loyalty, and improve brand image. Our user-centric
              development and creative design make your company stand out both
              domestically and globally.
            </p>
            <ul
              className="grid grid-cols-2 gap-x-8 gap-y-3 list-disc list-inside marker:text-blue-600 marker:text-2xl"
              style={{ listStyleType: "square", fontSize: "18px" }}
            >
              <li>Beautiful and contemporary interface designs</li>
              <li>Seamless user experiences that enhance interaction</li>
              <li>Higher retention and customer satisfaction</li>
              <li>
                Flexible designs that will keep pace with future requirements
              </li>
              <li>Greater brand awareness and recognition</li>
              <li>User-Centered Designs that Drive Conversions</li>
            </ul>
          </div>
        );
      case "custom-software-services":
        return (
          <div>
            <h3 className="details_item_info_title">
              Custom Software Development Outcome
            </h3>
            <p>
              Our Alwar Custom Software Development Solutions at RashTech Info
              are designed to deliver results that revolutionize your business.
              We create software that streamlines processes, boosts output, and
              eliminates laborious manual labour. Our custom apps give your
              business a major competitive edge and are simple to use and
              flexible. We promise that your software will grow with your
              company and continue to lead the market with regular updates and
              dependable long-term support.
            </p>
            <ul
              className="grid grid-cols-2 gap-x-8 gap-y-3 list-disc list-inside marker:text-blue-600 marker:text-2xl"
              style={{ listStyleType: "square", fontSize: "18px" }}
            >
              <li>Streamlined business processes and operations</li>
              <li>Improved efficiency through automation</li>
              <li>Flexible solutions that grow with you</li>
              <li>Improved data management and reporting</li>
              <li>Competitive advantage through our solutions</li>
              <li>Improved performance through regular support</li>
            </ul>
          </div>
        );
      case "e-commerce-solutions-services":
        return (
          <div>
            <h3 className="details_item_info_title">
              E-commerce Solutions Outcome
            </h3>
            <p>
              At RashTech Info, we don’t just build online stores, we deliver
              measurable results that help your business grow. Being the Best
              E-commerce Development Company in Alwar, what we do is design
              platforms that are simple to manage, scalable, and profitable. Our
              E-commerce Solutions in India and internationally are crafted to
              enhance user experience, increase engagement, and drive maximum
              sales. With cutting-edge features, secure payment, and
              user-friendly design, we make your online store future-proof and
              competitive in the international digital market.
            </p>
            <ul
              className="grid grid-cols-2 gap-x-8 gap-y-3 list-disc list-inside marker:text-blue-600 marker:text-2xl"
              style={{ listStyleType: "square", fontSize: "18px" }}
            >
              <li>Stronger online presence and brand credibility</li>
              <li>Increased sales and higher revenue growth</li>
              <li>Smooth shopping experiences with mobile-first design</li>
              <li>Secure payment integration for safe transactions</li>
              <li>Scalable platforms to support business expansion</li>
              <li>Better customer engagement with smart features</li>
            </ul>
          </div>
        );
      default:
        return (
          <div>
            <h3 className="details_item_info_title">Services Outcome</h3>
            <p>
              Our work delivers measurable impact: faster performance, stronger
              security, and scalable foundations; higher conversions,
              engagement, and retention; accessible, consistent experiences;
              streamlined operations with automation and flexible CMS/tools;
              actionable analytics powering continuous optimization; and
              empowered teams through training and documentation.
            </p>
          </div>
        );
    }
  };

  return <div className="service-outcome">{renderContent()}</div>;
};

export default ServiceOutcome;
